export function getOccurrenceOfMarket(referenceBetId, betArray) {
   	let occurrenceOfThisMarket = 0;
	for(let kb in betArray) {
		const otherOccurrence = betArray[kb];
		const betId = otherOccurrence.cs || otherOccurrence.id;
		if(betId == referenceBetId) {
			occurrenceOfThisMarket ++;
		}
	}
	return occurrenceOfThisMarket;
}
